import { render } from "./BaseAudio.vue?vue&type=template&id=250d587a"
import script from "./BaseAudio.vue?vue&type=script&lang=js"
export * from "./BaseAudio.vue?vue&type=script&lang=js"

import "./BaseAudio.vue?vue&type=style&index=0&id=250d587a&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__